import { getTimeZones } from '@vvo/tzdb'

const formatGmtOffset = (minutes: number): string => {
  const sign = minutes >= 0 ? '+' : '-'
  const absMinutes = Math.abs(minutes)
  const hours = Math.floor(absMinutes / 60)
  const mins = absMinutes % 60

  const paddedHours = String(hours).padStart(2, '0')
  const paddedMins = String(mins).padStart(2, '0')

  return `GMT${sign}${paddedHours}:${paddedMins}`
}

// Get available timezone items should be function to get current timezone while considering daylight saving time
export const getAvailableTimezoneItems = () =>
  getTimeZones().map(
    ({ name, alternativeName, currentTimeOffsetInMinutes }) => {
      const text = `${alternativeName} - ${name?.split('/').pop()?.replace(/_/g, ' ')}`
      const subText = formatGmtOffset(currentTimeOffsetInMinutes)
      // add both text and subtext as key to be enable searching in both
      return {
        value: name,
        text,
        subText,
      }
    },
  )
